const appConfig = {
  // backend url (with slash at end)
  URL: 'https://plattenseeimmo.hu/',
  CONTACTEMAIL: 'info@whitewebdesign.hu',
  DEFAULTLANG: 'en',
};

export default appConfig;
